'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { lang, tr } from '../../utils/helpers';

const presences = {
  init() {
    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (currentSlide == 'volunteers') {
        if ($("input[name='total_employees']").val() == '') {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      if (currentSlide == 'hours') {
        if ($("input[name='total_time_action']").val() == '') {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      if (currentSlide == 'benefiteds') {
        if (
          $("input[name='total_benefited_child']").val() == '' ||
          $("input[name='total_young']").val() == '' ||
          $("input[name='total_adults']").val() == '' ||
          $("input[name='total_seniors']").val() == ''
        ) {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $('.back').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (nextSlide == 'rede') {
        if ($("input[name='volunteer_type']:checked").val() == 'employee') {
          nextSlide = 'rede';
        } else {
          nextSlide = 'state';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $(window).on('keydown', function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  },
};

export default presences;
